<b-modal v-model="modal_special_requirement_DCM5" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid">
        <div class="w-100">
          <!-- wait 以外は従来のメッセージ -->
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
          <!-- phase が wait のときだけテーブルを表示 -->
          <cstm-table v-if="phase === 'wait'" id="cstm-table" useStripeStyle hasTabs initSortDir="asc" rowSelect
            :items="tableItems" :columns="systemTableColumns" type="simple" @rowClicked="onSelectItem" />
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonCancel" size="sm" :disabled="isLoading" variant="outline-primary"
        @click="onCancelClicked" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" :disabled="isOkDisabled" variant="primary" @click="onOkClicked"
        class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>